import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaHome, FaSearch, FaExclamationTriangle } from 'react-icons/fa';
import Seo from 'shared/seo/Seo';
import { pageMeta } from 'shared/seo/seoMeta';
import './NotFound.css';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found-wrapper">
      {/*
        No canonical here — on purpose. This used to canonicalise every 404 to
        "/", which told Google that each dead URL *was* the homepage. A 404 must
        carry noindex and nothing else.
      */}
      <Seo
        title={pageMeta.notFound.title}
        description={pageMeta.notFound.description}
        noindex
      />
      <Container>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Col className="align-items-center">

            <div className="text-center">
              <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
              >
                <div className="error-icon">
                  <FaExclamationTriangle />
                </div>

              </motion.div>
            </div>

            <Col lg={6} className="text-center text-lg-start mb-5 mb-lg-0">
              {/* The "404" is decoration; the h1 carries the actual message. */}
              <div className="error-code" aria-hidden="true">404</div>
              <h1 className="error-title">{t('common.notFound.title', 'Page introuvable')}</h1>
              <p className="error-description">
                {t('common.notFound.description', 'La page que vous recherchez a peut-être été supprimée, son nom a peut-être été modifié ou elle est temporairement indisponible.')}
              </p>
              
              <div className="buttons-wrapper-container">
                <Link to="/" className="btn btn-primary btn-lg d-flex align-items-center justify-content-center">
                  <FaHome className="me-2" />
                  {t('common.notFound.backHome', 'Retourner a l\'accueil')}
                </Link>
                <Link to="/contact" className="btn btn-outline-primary btn-lg d-flex align-items-center justify-content-center">
                  <FaSearch className="me-2" />
                  {t('common.contactUs', 'Contactez-nous')}
                </Link>
              </div>
            </Col>

          </Col>
        </motion.div>
      </Container>
    </div>
  );
};

export default NotFound;
